import React, { useState } from "react";
import { Link } from "react-router-dom";
import ReorderIcon from "@material-ui/icons/Reorder";
import logo from "../assets/logo.png";
import "../styles/Navbar.css";

function Navbar() {
  const [openLinks, setOpenLinks] = useState(false);

  const toggleNavbar = () => {
    setOpenLinks(!openLinks);
  };

  const closeMenu = () => {
    setOpenLinks(false);
  };

  return (
    <div className="navbar">
      <div className="leftSide">
        <img src={logo} alt="Get Karigar Logo" className="logo" />
      </div>
      <div className="rightSide">
        <Link to="/"> Home </Link>
        <Link to="/menu"> Services </Link>
        <Link to="/gallery"> Gallery </Link>
        <Link to="/about"> About </Link>
        <Link to="/contact"> Contact </Link>
        <button onClick={toggleNavbar} className="menu-toggle">
          <ReorderIcon />
        </button>
      </div>
      
      {/* Mobile Slide-in Menu */}
      <div className={`mobile-menu ${openLinks ? 'open' : ''}`}>
        <div className="mobile-menu-header">
          <img src={logo} alt="Get Karigar Logo" className="mobile-logo" />
          <button onClick={closeMenu} className="close-button">×</button>
        </div>
        <div className="mobile-menu-links">
          <Link to="/" onClick={closeMenu}> Home </Link>
          <Link to="/menu" onClick={closeMenu}> Services </Link>
          <Link to="/gallery" onClick={closeMenu}> Gallery </Link>
          <Link to="/about" onClick={closeMenu}> About </Link>
          <Link to="/contact" onClick={closeMenu}> Contact </Link>
        </div>
      </div>
      
      {/* Overlay */}
      {openLinks && <div className="menu-overlay" onClick={closeMenu}></div>}
    </div>
  );
}

export default Navbar;
